import React from "react";

const  OutForDelivery = (props) => {
  return (
<svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 18V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H5" stroke="#5AA77C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 18H9" stroke="#5AA77C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17V13.35C21.9996 13.1231 21.922 12.903 21.78 12.726L18.3 8.376C18.2065 8.25888 18.0878 8.16428 17.9528 8.0992C17.8178 8.03412 17.6699 8.00021 17.52 8H14" stroke="#5AA77C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z" stroke="#5AA77C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 20C8.10457 20 9 19.1046 9 18C9 16.8954 8.10457 16 7 16C5.89543 16 5 16.8954 5 18C5 19.1046 5.89543 20 7 20Z" stroke="#5AA77C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


  );
};

export default  OutForDelivery;
